// components/GlassDetailsModal.js - Исправленная версия без ошибок
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL } from '../config';

const API_BASE_URL = `${API_URL}/api`;

// Конфигурация полей стекла из Битрикс24
const GLASS_FIELDS = {
  'ufCrm3_1751274844238': {
    name: 'Прозрачный 8 мм',
    thickness: '8мм',
    type: 'Прозрачный',
    color: 'transparent'
  },
  'ufCrm3_1751274861103': {
    name: 'Бронза 8 мм',
    thickness: '8мм',
    type: 'Бронза',
    color: 'bronze'
  },
  'ufCrm3_1754027324300': {
    name: 'Бронза 10 мм',
    thickness: '10мм',
    type: 'Бронза',
    color: 'bronze'
  },
  'ufCrm3_1751275030885': {
    name: 'Прозрачный 4 мм',
    thickness: '4мм',
    type: 'Прозрачный',
    color: 'transparent'
  },
  'ufCrm3_1751275041994': {
    name: 'Бронза 4 мм',
    thickness: '4мм',
    type: 'Бронза',
    color: 'bronze'
  },
  'ufCrm3_1751275050612': {
    name: 'Графит 4 мм',
    thickness: '4мм',
    type: 'Графит',
    color: 'graphite'
  },
  'ufCrm3_1751275363654': {
    name: 'Прозрачный 6 мм',
    thickness: '6мм',
    type: 'Прозрачный',
    color: 'transparent'
  },
  'ufCrm3_1751275374960': {
    name: 'Прозрачный 10 мм',
    thickness: '10мм',
    type: 'Прозрачный',
    color: 'transparent'
  },
  'ufCrm3_1754027253985': {
    name: 'Графит 6 мм',
    thickness: '6мм',
    type: 'Графит',
    color: 'graphite'
  },
  'ufCrm3_1751279653655': {
    name: 'Графит 8 мм',
    thickness: '8мм',
    type: 'Графит',
    color: 'graphite'
  }
};

const GlassDetailsModal = ({ orderId, orderNumber, orderTitle, stage, isProblemOrder = false, onClose }) => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [glassDetails, setGlassDetails] = useState([]);
  const [selectedDetails, setSelectedDetails] = useState(new Set());
  const [selectedQuantities, setSelectedQuantities] = useState(new Map());
  const [comments, setComments] = useState('');
  const [unselectedComments, setUnselectedComments] = useState('');
  const [responsibleComments, setResponsibleComments] = useState('');

  // Названия стадий
  const getStageTitle = () => {
    const stageTitles = {
      'rezka': 'Резка / Кесу',
      'drilling': 'Сверление / Тесу',
      'zakalka': 'Закалка / Қайнату', 
      'upakovka': 'Упаковка / Орау',
      'matovka': 'Матовка / Матовка',
      'loft': 'Лофт / Лофт'
    };
    return stageTitles[stage] || stage;
  };

  // Загрузка данных при открытии модального окна
  useEffect(() => {
    loadGlassDetails();
  }, [orderId, stage]);

  const loadGlassDetails = async () => {
    try {
      console.time('loadGlassDetails');
      setLoading(true);
      setError(null);

      const token = localStorage.getItem('token');
      
      console.time('API request');
      const response = await axios.get(`${API_BASE_URL}/glass-details-fixed/${orderId}`, {
        params: {
          stage: stage,
          isProblemOrder: isProblemOrder
        },
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      console.timeEnd('API request');

      if (response.data.success) {
        const { glassDetails, savedState } = response.data;
        setGlassDetails(glassDetails || []);
        
        // Загружаем сохраненное состояние
        if (savedState) {
          try {
            // Безопасно парсим выбранные детали из полной JSON структуры
            let selectedIds = [];
            if (savedState.selected) {
              // Проверяем, это JSON или простой текст
              if (savedState.selected.startsWith('[') || savedState.selected.startsWith('{')) {
                // Это JSON - парсим структуру
                const parsed = JSON.parse(savedState.selected);
                if (Array.isArray(parsed)) {
                  // Старый формат - массив ID
                  selectedIds = parsed;
                } else if (parsed && parsed.selectedDetails && Array.isArray(parsed.selectedDetails)) {
                  // Новый формат - полная структура с selectedDetails
                  selectedIds = parsed.selectedDetails.map(detail => detail.id);
                  console.log('Найдена полная структура от резки:', {
                    stage: parsed.stage,
                    selectedCount: parsed.selectedCount,
                    unselectedCount: parsed.unselectedCount,
                    user: parsed.user?.username
                  });
                  
                  // Показываем информацию о том, что выбрала резка
                  if (!savedState.comments && parsed.selectedDetails.length > 0) {
                    const selectedSummary = parsed.selectedDetails
                      .map(d => d.originalText || `${d.glassType} ${d.height}×${d.width}мм`)
                      .join('; ');
                    setComments(`Выбрано резкой (${parsed.user?.username}): ${selectedSummary}`);
                  }
                }
              } else {
                // Это простой текст - показываем в комментариях для информации
                console.log('Обнаружен старый текстовый формат деталей от резки:', savedState.selected);
                if (!savedState.comments) {
                  setComments(`Данные от резки: ${savedState.selected}`);
                }
              }
            }
            setSelectedDetails(new Set(selectedIds));
            
            // Безопасно парсим количества
            let quantitiesMap = new Map();
            if (savedState.quantities) {
              const parsed = JSON.parse(savedState.quantities);
              if (parsed && typeof parsed === 'object') {
                Object.entries(parsed).forEach(([key, value]) => {
                  quantitiesMap.set(key, parseInt(value) || 1);
                });
              }
            }
            setSelectedQuantities(quantitiesMap);
            
            setComments(savedState.comments || '');
            setUnselectedComments(savedState.unselectedComments || '');
            setResponsibleComments(savedState.responsibleComments || '');
            
            console.log('Загружено состояние:', {
              selectedCount: selectedIds.length,
              quantitiesCount: quantitiesMap.size,
              hasComments: !!(savedState.comments),
              hasUnselectedComments: !!(savedState.unselectedComments)
            });
            
          } catch (parseError) {
            console.error('Ошибка парсинга сохраненного состояния:', parseError);
            console.log('Сырые данные состояния:', savedState);
            
            // Сбрасываем к начальным значениям при ошибке
            setSelectedDetails(new Set());
            setSelectedQuantities(new Map());
            setComments('');
            setUnselectedComments('');
            setResponsibleComments('');
          }
        } else {
          // Если нет сохраненного состояния, но есть preSelected элементы
          const preSelectedIds = [];
          const preSelectedQuantities = new Map();
          
          glassDetails.forEach(detail => {
            if (detail.preSelected) {
              preSelectedIds.push(detail.id);
              preSelectedQuantities.set(detail.id, detail.quantity || 1);
            }
          });
          
          if (preSelectedIds.length > 0) {
            setSelectedDetails(new Set(preSelectedIds));
            setSelectedQuantities(preSelectedQuantities);
            console.log('Применены предвыбранные элементы:', preSelectedIds.length);
          }
        }
      } else {
        setError(response.data.message || 'Ошибка загрузки данных');
      }
    } catch (err) {
      console.error('Ошибка загрузки деталировки:', err);
      setError(`Ошибка загрузки: ${err.message}`);
    } finally {
      setLoading(false);
      console.timeEnd('loadGlassDetails');
    }
  };

  // Автосохранение состояния на сервере
  const autoSaveState = async () => {
    try {
      const token = localStorage.getItem('token');

      // Преобразуем Map в обычный объект для отправки
      const quantitiesObject = {};
      selectedQuantities.forEach((value, key) => {
        quantitiesObject[key] = value;
      });

      await axios.post(`${API_BASE_URL}/glass-details/${orderId}/save`, {
        stage,
        selectedDetails: Array.from(selectedDetails),
        selectedQuantities: quantitiesObject,
        comments,
        unselectedComments,
        responsibleComments,
        glassDetails: glassDetails,
        autoSave: true
      }, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      console.log(`✅ Автосохранение для ${stage} выполнено`);
    } catch (error) {
      console.error(`❌ Ошибка автосохранения:`, error);
    }
  };

  // Обработка изменения чекбоксов с автосохранением
  const handleDetailToggle = (detailId, detail) => {
    setSelectedDetails(prev => {
      const newSet = new Set(prev);
      if (newSet.has(detailId)) {
        newSet.delete(detailId);
        // Удаляем количество при снятии галочки
        setSelectedQuantities(prevQty => {
          const newMap = new Map(prevQty);
          newMap.delete(detailId);
          return newMap;
        });
      } else {
        newSet.add(detailId);
        // Устанавливаем изначальное количество при выборе
        setSelectedQuantities(prevQty => {
          const newMap = new Map(prevQty);
          newMap.set(detailId, detail.quantity || 1);
          return newMap;
        });
      }

      // Автосохранение с небольшой задержкой
      setTimeout(() => {
        autoSaveState();
      }, 500);

      return newSet;
    });
  };

  // Обработка изменения количества с автосохранением
  const handleQuantityChange = (detailId, newQuantity, maxQuantity) => {
    if (newQuantity < 1) newQuantity = 1;
    if (newQuantity > maxQuantity) newQuantity = maxQuantity;

    setSelectedQuantities(prev => {
      const newMap = new Map(prev);
      newMap.set(detailId, newQuantity);

      // Автосохранение с задержкой
      setTimeout(() => {
        autoSaveState();
      }, 1000);

      return newMap;
    });
  };

  // Получение выбранного количества для детали
  const getSelectedQuantity = (detailId, defaultQuantity) => {
    return selectedQuantities.get(detailId) || defaultQuantity || 1;
  };

  // Выбрать все детали
  const handleSelectAll = () => {
    // Для матовки выбираем только предварительно выбранные детали
    const availableDetails = stage === 'matovka' 
      ? filteredGlassDetails.filter(detail => detail.preSelected)
      : filteredGlassDetails;
    
    const allIds = availableDetails.map(detail => detail.id);
    setSelectedDetails(new Set(allIds));
    
    // Устанавливаем изначальные количества для всех доступных деталей
    const newQuantities = new Map();
    availableDetails.forEach(detail => {
      newQuantities.set(detail.id, detail.quantity || 1);
    });
    setSelectedQuantities(newQuantities);
  };

  // Снять все выделения
  const handleDeselectAll = () => {
    setSelectedDetails(new Set());
    setSelectedQuantities(new Map());
  };

  // Фильтрация деталей на основе параметра "п"
  const filteredGlassDetails = React.useMemo(() => {
    console.log('Все детали:', glassDetails);
    const hasHideOthersParam = glassDetails.some(detail => detail.specialParams?.hideOthers);
    console.log('Есть параметр "п":', hasHideOthersParam);
    
    if (hasHideOthersParam) {
      const filtered = glassDetails.filter(detail => detail.specialParams?.hideOthers);
      console.log('Отфильтрованные детали с "п":', filtered);
      return filtered;
    }
    return glassDetails;
  }, [glassDetails]);

  // Группировка деталей по типу стекла
  const groupedDetails = filteredGlassDetails.reduce((groups, detail) => {
    const key = detail.glassType;
    if (!groups[key]) {
      groups[key] = [];
    }
    groups[key].push(detail);
    return groups;
  }, {});

  // Сохранение состояния
  const handleSave = async () => {
    try {
      setSaving(true);
      setError(null);

      const token = localStorage.getItem('token');
      
      // Преобразуем Map в обычный объект для отправки
      const quantitiesObject = {};
      selectedQuantities.forEach((value, key) => {
        quantitiesObject[key] = value;
      });

      const response = await axios.post(`${API_BASE_URL}/glass-details/${orderId}/save`, {
        stage,
        selectedDetails: Array.from(selectedDetails),
        selectedQuantities: quantitiesObject,
        comments,
        unselectedComments,
        responsibleComments,
        glassDetails: glassDetails // ← ДОБАВЛЯЕМ полные данные деталей
      }, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (response.data.success) {
        alert('Деталировка успешно сохранена!');
        onClose();
      } else {
        setError(response.data.message || 'Ошибка сохранения');
      }
    } catch (err) {
      console.error('Ошибка сохранения:', err);
      console.error('Детали ошибки:', err.response?.data);
      
      let errorMessage = 'Неизвестная ошибка';
      
      if (err.response?.data?.message) {
        errorMessage = err.response.data.message;
      } else if (err.message) {
        errorMessage = err.message;
      }
      
      setError(`Ошибка сохранения: ${errorMessage}`);
    } finally {
      setSaving(false);
    }
  };

  // Получение цвета для типа стекла
  const getGlassTypeColor = (color) => {
    const colors = {
      'transparent': 'bg-blue-100 border-blue-200 text-blue-800',
      'bronze': 'bg-yellow-100 border-yellow-200 text-yellow-800', 
      'graphite': 'bg-gray-100 border-gray-200 text-gray-800',
      'default': 'bg-gray-100 border-gray-200 text-gray-800'
    };
    return colors[color] || 'bg-gray-100 border-gray-200 text-gray-800';
  };

  // Обработка нажатия Escape
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [onClose]);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-2 sm:p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-5xl w-full max-h-[95vh] sm:max-h-[90vh] flex flex-col">
        {/* Заголовок */}
        <div className="flex justify-between items-center p-4 sm:p-6 border-b border-gray-200 flex-shrink-0">
          <div className="flex-1 min-w-0">
            <h2 className="text-lg sm:text-xl font-bold text-gray-900 truncate">
              Деталировка стекла - {getStageTitle()}
            </h2>
            <p className="text-sm text-gray-600 truncate">
              Тапсырыс №{orderNumber} - {orderTitle}
            </p>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 text-2xl font-bold ml-4 p-2 -m-2"
          >
            ×
          </button>
        </div>

        {/* Содержимое */}
        <div className="p-4 sm:p-6 overflow-y-auto flex-1 min-h-0">
          {loading ? (
            <div className="flex justify-center items-center py-8">
              <div className="text-lg">Жүктелуде...</div>
            </div>
          ) : error ? (
            <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded mb-4">
              <strong>Қате:</strong> {error}
            </div>
          ) : (
            <>
              {/* Кнопки управления */}
              <div className="flex justify-between items-center mb-4">
                {stage !== 'drilling' && (
                  <div className="flex space-x-2">
                    <button
                      onClick={handleSelectAll}
                      className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded text-sm"
                    >
                      Барлығын таңдау
                    </button>
                    <button
                      onClick={handleDeselectAll}
                      className="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded text-sm"
                    >
                      Барлығын алып тастау
                    </button>
                  </div>
                )}

                {/* Статистика */}
                <div className="bg-blue-50 border border-blue-200 px-3 py-2 rounded">
                  {stage === 'drilling' ? (
                    <span className="text-sm text-blue-800">
                      Доступно для сверления: <strong>{glassDetails.filter(d => d.selectedByCutter).length}</strong> из {glassDetails.length}
                    </span>
                  ) : stage === 'matovka' ? (
                    <span className="text-sm text-blue-800">
                      Доступно для матовки: <strong>{glassDetails.filter(d => d.preSelected).length}</strong> из {glassDetails.length} | Выбрано: <strong>{selectedDetails.size}</strong>
                    </span>
                  ) : (
                    <span className="text-sm text-blue-800">
                      Таңдалған: <strong>{selectedDetails.size}</strong> из {glassDetails.length}
                    </span>
                  )}
                </div>
              </div>

              {/* Список деталей стекла по типам */}
              {Object.keys(groupedDetails).length === 0 ? (
                <div className="text-center py-8 text-gray-500">
                  {stage === 'drilling' ? (
                    <div>
                      <div className="text-lg mb-2">Резчик еще не выбрал детали</div>
                      <div className="text-sm">
                        Детали для сверления появятся после того, как резчик завершит свою работу и выберет нужные детали.
                      </div>
                    </div>
                  ) : (
                    <div>
                      <div className="text-lg mb-2">Стекло деталировки табылмады</div>
                      <div className="text-sm">
                        Тапсырыста келесі өрістер толтырылмаған:
                        <ul className="mt-2 text-xs text-left max-w-md mx-auto">
                          {Object.values(GLASS_FIELDS).map(field => (
                            <li key={field.name} className="py-1">• {field.name}</li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <div className="space-y-6">
                  {Object.entries(groupedDetails).map(([glassType, details]) => (
                    <div key={glassType} className="border border-gray-200 rounded-lg p-4">
                      {/* Заголовок группы */}
                      <div className={`inline-block px-3 py-1 rounded-full text-sm font-medium mb-4 ${
                        getGlassTypeColor(details[0].glassConfig?.color || 'default')
                      }`}>
                        {glassType}
                      </div>

                      {/* Детали в группе */}
                      <div className="space-y-3">
                        {details.map((detail) => {
                          const selectedQuantity = getSelectedQuantity(detail.id, detail.quantity);
                          const isSelected = selectedDetails.has(detail.id);
                          const maxQuantity = detail.quantity || 1;
                          const isDisabled = (stage === 'drilling' && detail.disabled) || (stage === 'matovka' && !detail.preSelected);
                          const isSelectedByCutter = stage === 'drilling' && detail.selectedByCutter;
                          
                          // Определяем специальные стили на основе параметров
                          const getSpecialStyles = () => {
                            if (detail.specialParams?.stripedRed) {
                              return 'border-red-400 bg-red-50 bg-gradient-to-r from-red-100 to-transparent bg-[length:20px_20px] bg-repeat-x';
                            }
                            if (detail.specialParams?.transparentRed) {
                              return 'border-red-300 bg-red-50 bg-opacity-30';
                            }
                            return '';
                          };
                          
                          const specialStyles = getSpecialStyles();
                          
                          return (
                            <div
                              key={detail.id}
                              className={`border rounded-lg p-4 transition-colors ${
                                specialStyles || (
                                  isDisabled
                                    ? 'border-gray-300 bg-gray-100 opacity-60'
                                    : isSelected
                                    ? 'border-green-300 bg-green-50'
                                    : 'border-gray-200 bg-gray-50'
                                )
                              }`}
                              style={
                                detail.specialParams?.stripedRed 
                                  ? {
                                      backgroundImage: 'repeating-linear-gradient(45deg, transparent, transparent 10px, rgba(239, 68, 68, 0.2) 10px, rgba(239, 68, 68, 0.2) 20px)'
                                    }
                                  : detail.specialParams?.transparentRed
                                  ? {
                                      backgroundColor: 'rgba(239, 68, 68, 0.1)'
                                    }
                                  : {}
                              }
                            >
                              <div className="flex items-center space-x-3">
                                <input
                                  type="checkbox"
                                  id={`detail-${detail.id}`}
                                  checked={isSelected}
                                  onChange={() => handleDetailToggle(detail.id, detail)}
                                  disabled={isDisabled}
                                  className={`h-5 w-5 text-green-600 rounded ${
                                    isDisabled ? 'cursor-not-allowed opacity-50' : ''
                                  }`}
                                />
                                <label
                                  htmlFor={`detail-${detail.id}`}
                                  className={`flex-1 ${
                                    isDisabled ? 'cursor-not-allowed text-gray-500' : 'cursor-pointer'
                                  }`}
                                >
                                  <div className="font-medium text-gray-900">
                                    {detail.originalText}
                                  </div>
                                  {detail.height && detail.width && (
                                    <div className="text-sm text-gray-600 mt-1">
                                      <span className="inline-block bg-gray-200 px-2 py-1 rounded mr-2">
                                        В: {detail.height}мм
                                      </span>
                                      <span className="inline-block bg-gray-200 px-2 py-1 rounded mr-2">
                                        Ш: {detail.width}мм
                                      </span>
                                      <span className="inline-block bg-purple-200 px-2 py-1 rounded mr-2">
                                        Изначально: {maxQuantity}шт
                                      </span>
                                      {detail.area && (
                                        <span className="inline-block bg-green-200 px-2 py-1 rounded mr-2">
                                          Аудан: {detail.area} м²
                                        </span>
                                      )}
                                    </div>
                                  )}
                                  {/* Информация о предыдущей стадии */}
                                  {detail.preSelected && stage !== 'drilling' && stage !== 'matovka' && (
                                    <div className="text-xs text-green-600 mt-2 bg-green-50 border border-green-200 rounded p-2">
                                      <div className="font-medium">✓ Выбрано на предыдущей стадии</div>
                                      {detail.zakalkaInfo && (
                                        <>
                                          <div>Ответственный: {detail.zakalkaInfo.user?.username || detail.zakalkaInfo.user}</div>
                                          <div>Дата: {new Date(detail.zakalkaInfo.timestamp).toLocaleString('ru-RU')}</div>
                                          {detail.zakalkaInfo.comments && (
                                            <div>Комментарий: {detail.zakalkaInfo.comments}</div>
                                          )}
                                        </>
                                      )}
                                    </div>
                                  )}
                                  {/* Информация для drilling стадии */}
                                  {stage === 'drilling' && isSelectedByCutter && (
                                    <div className="text-xs text-blue-600 mt-2 bg-blue-50 border border-blue-200 rounded p-2">
                                      <div className="font-medium">✓ Выбрано резчиком для сверления</div>
                                    </div>
                                  )}
                                </label>
                                
                                {/* Секция выбора количества и статуса */}
                                <div className="flex flex-col items-end space-y-2">
                                  {/* Статус */}
                                  <div className="text-sm font-medium">
                                    {stage === 'drilling' && isDisabled ? (
                                      <span className="text-gray-500">○ Недоступно</span>
                                    ) : stage === 'drilling' && isSelectedByCutter ? (
                                      <span className="text-blue-600">✓ Доступно для сверления</span>
                                    ) : stage === 'matovka' && detail.preSelected && isSelected ? (
                                      <span className="text-green-600">✓ Выбрано для матовки</span>
                                    ) : stage === 'matovka' && detail.preSelected && !isSelected ? (
                                      <span className="text-blue-600">○ Доступно для матовки</span>
                                    ) : stage === 'matovka' && !detail.preSelected ? (
                                      <span className="text-gray-500">○ Недоступно</span>
                                    ) : isSelected ? (
                                      <span className="text-green-600">✓ Таңдалған</span>
                                    ) : (
                                      <span className="text-red-600">○ Таңдалмаған</span>
                                    )}
                                  </div>
                                  
                                  {/* Контроллер количества (показывается только если выбрано) */}
                                  {isSelected && (
                                    <div className="flex items-center space-x-2 bg-white rounded-lg border border-gray-300 p-1">
                                      <button
                                        type="button"
                                        onClick={() => handleQuantityChange(detail.id, selectedQuantity - 1, maxQuantity)}
                                        disabled={selectedQuantity <= 1}
                                        className={`w-8 h-8 rounded flex items-center justify-center text-lg font-bold ${
                                          selectedQuantity <= 1
                                            ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                                            : 'bg-red-100 hover:bg-red-200 text-red-600 cursor-pointer'
                                        }`}
                                      >
                                        −
                                      </button>
                                      
                                      <div className="flex flex-col items-center">
                                        <span className="text-lg font-bold text-gray-900 min-w-[3rem] text-center">
                                          {selectedQuantity}
                                        </span>
                                        <span className="text-xs text-gray-500">шт</span>
                                      </div>
                                      
                                      <button
                                        type="button"
                                        onClick={() => handleQuantityChange(detail.id, selectedQuantity + 1, maxQuantity)}
                                        disabled={selectedQuantity >= maxQuantity}
                                        className={`w-8 h-8 rounded flex items-center justify-center text-lg font-bold ${
                                          selectedQuantity >= maxQuantity
                                            ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                                            : 'bg-green-100 hover:bg-green-200 text-green-600 cursor-pointer'
                                        }`}
                                      >
                                        +
                                      </button>
                                    </div>
                                  )}
                                  
                                  {/* Показываем общую площадь если количество > 1 */}
                                  {isSelected && selectedQuantity > 1 && detail.area && (
                                    <div className="text-xs text-blue-600 bg-blue-100 px-2 py-1 rounded">
                                      Жалпы: {(parseFloat(detail.area) * selectedQuantity).toFixed(2)} м²
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {/* Комментарии */}
              <div className="space-y-4 mt-6">
                <div>
                  <label htmlFor="general-comments" className="block text-sm font-medium text-gray-700 mb-2">
                    Жалпы түсініктемелер:
                  </label>
                  <textarea
                    id="general-comments"
                    value={comments}
                    readOnly
                    className="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-100 text-gray-700 cursor-not-allowed"
                    rows="3"
                    placeholder="Бұл өріс тек оқуға арналған..."
                  />
                </div>

                {/* Поле для комментариев ответственного (для всех стадий) */}
                {(stage === 'drilling' || stage === 'rezka' || stage === 'zakalka' || stage === 'matovka') && (
                  <div>
                    <label htmlFor="responsible-comments" className="block text-sm font-medium text-gray-700 mb-2">
                      Комментарий ответственного:
                    </label>
                    <textarea
                      id="responsible-comments"
                      value={responsibleComments}
                      onChange={(e) => setResponsibleComments(e.target.value)}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      rows="2"
                      placeholder="Дополнительные комментарии от ответственного..."
                    />
                    <p className="text-xs text-gray-500 mt-1">
                      {stage === 'drilling' 
                        ? 'Этот комментарий сохраняется отдельно для ответственного за сверление'
                        : stage === 'rezka'
                        ? 'Этот комментарий сохраняется отдельно для ответственного за резку'
                        : stage === 'zakalka'
                        ? 'Этот комментарий сохраняется отдельно для ответственного за закалку'
                        : 'Этот комментарий сохраняется отдельно для ответственного за матовку'
                      }
                    </p>
                  </div>
                )}
                
                <div>
                  <p className="text-xs text-gray-500 mt-1">
                    Бұл түсініктемелер кесу сатысына қайта өңдеу үшін жіберіледі
                  </p>
                </div>
              </div>
            </>
          )}
        </div>

        {/* Футер с кнопками */}
        <div className="flex flex-col sm:flex-row justify-end space-y-2 sm:space-y-0 sm:space-x-3 p-4 sm:p-6 border-t border-gray-200 flex-shrink-0">
          <button
            onClick={onClose}
            className="w-full sm:w-auto px-4 py-3 sm:py-2 text-gray-700 bg-gray-200 hover:bg-gray-300 rounded transition-colors font-medium"
          >
            Жабу
          </button>
          <button
            onClick={handleSave}
            disabled={saving || loading || glassDetails.length === 0}
            className={`w-full sm:w-auto px-6 py-3 sm:py-2 text-white rounded transition-colors font-medium ${
              saving || loading || glassDetails.length === 0
                ? 'bg-gray-400 cursor-not-allowed'
                : 'bg-blue-500 hover:bg-blue-600'
            }`}
          >
            {saving ? 'Сақталуда...' : 'Сақтау'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default GlassDetailsModal;